import React from 'react'
import { Container, Typography, makeStyles } from '@material-ui/core'
import { useTheme } from '@material-ui/core'

export const Article = ({title, body}) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  return (
    <Container className={classes.container}>
      <Typography variant="h6">
        { title }
      </Typography>
      <Typography variant="body1">
        { body }
      </Typography>
    </Container>
  )
}

const useStyles = makeStyles({
  container: theme => ({
    margin: '1rem 0'
  })
})